export default function ConceptCard({ frameNo, title, body, theme = 'dark' }) {
  if (theme === 'industry') {
    return (
      <div
        className="blueprint flex flex-1 flex-col gap-[5px] bg-white px-[18px] py-[14px]"
        style={{ borderColor: 'var(--color-neutral-400)' }}
      >
        <i className="corner tl" />
        <i className="corner tr" />
        <i className="corner bl" />
        <i className="corner br" />
        <div className="font-heading text-[10px] tracking-[3px] font-semibold text-accent-700">
          FRAME {frameNo} · CONCEPT
        </div>
        <div className="font-heading text-[19px] font-semibold tracking-[0.5px]">{title}</div>
        <div className="text-[12.5px] leading-[1.55] text-neutral-800">{body}</div>
      </div>
    )
  }

  return (
    <div
      className="flex flex-1 flex-col gap-[5px] rounded-[10px] px-4 py-3"
      style={{
        background: 'rgba(255,255,255,0.055)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderLeft: '3px solid #e2a93b',
      }}
    >
      <div className="text-[9px] tracking-[2px] font-bold text-[#e2a93b]">FRAME {frameNo} · CONCEPT</div>
      <div className="text-[15px] font-bold">{title}</div>
      <div className="text-[12px] leading-[1.55] opacity-80">{body}</div>
    </div>
  )
}
